import { Observable, of } from 'rxjs';

export function void$(): Observable<void> {
  return of(undefined);
}
